import React, { useRef } from 'react'
import { Form } from 'antd'
import { Formik } from 'formik'
import { Modal } from 'antd'
import { object, string } from 'yup'
import { useTranslation } from 'react-i18next'

import { SelectResource } from 'src/components/Formik'

interface ModalLinkReasonProps {
  onSubmit: (values: any) => void
  toggle: () => void
  visible: boolean
}

export default function ModalLinkReason({
  onSubmit,
  toggle,
  visible
}: ModalLinkReasonProps) {
  const refFormik = useRef(null)
  const { t } = useTranslation()
  return (
    <Modal
      destroyOnClose
      okButtonProps={{
        //@ts-ignore
        'data-test-id': 'policy-reasons-new'
      }}
      okText={t('common.actions.continue')}
      onCancel={toggle}
      onOk={() => refFormik.current.submitForm()}
      title={t('web.policies.rules.modal-title-reason')}
      visible={visible}
      width={320}
    >
      <Formik
        initialValues={{ reason_id: '' }}
        onSubmit={onSubmit}
        ref={refFormik}
        render={formikProps => (
          <Form onSubmit={formikProps.handleSubmit}>
            <SelectResource
              autoFocus
              formikProps={formikProps}
              keyLabel="name"
              keyValue="reason_id"
              label="web.setup.form.reason.title"
              name="reason_id"
              placeholder="web.setup.form.reason.placeholder"
              resource="reasons"
            />
          </Form>
        )}
        validationSchema={object().shape({
          reason_id: string().required()
        })}
      />
    </Modal>
  )
}
